import { apiClient } from '@/lib/api/api-client'

import type { OrganizationPricing } from '@scrambl/shared'

/**
 * What this organization pays per plan and interval, including any custom
 * price and scheduled change (docs/PLAN-pricing-overrides.md).
 */
export const pricingApi = {
  get: async (organizationId: string): Promise<OrganizationPricing> =>
    (
      await apiClient<{ data: OrganizationPricing }>(
        `/subscriptions/organizations/${encodeURIComponent(organizationId)}/pricing`,
      )
    ).data,
}
